import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import MarkdownRender from 'components/Luxkit/MarkdownRender'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { sortBy } from 'lib/arrayUtils'

const DetailsDescription = styled(MarkdownRender)`
  margin-top: ${rem(12)};
`

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`

const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(8)};
`

interface Props {
  pkg: App.Package
}

function RoomDetails(props: Props) {
  const { pkg } = props

  const sortedAmenities = useMemo(() => {
    if (!pkg.roomType) {
      return []
    }

    return sortBy(pkg.roomType.amenities, (a) => a.name, 'asc')
  }, [pkg.roomType])

  return (
    <Container>
      <Section>
        <BodyText variant="medium" weight="bold">
          Room facilities:
        </BodyText>
        {sortedAmenities.map((amenity) => (
          <BodyText as="li" variant="small" key={amenity.id}>
            {amenity.name}
          </BodyText>
        ))}
      </Section>
      {pkg.roomPolicyDescription && (
        <Section>
          <BodyText variant="medium" weight="bold">
            Room policies:
          </BodyText>
          <DetailsDescription
            fontSize="medium"
            content={pkg.roomPolicyDescription}
            type="compact"
          />
        </Section>
      )}
    </Container>
  )
}

export default React.memo(RoomDetails)
